import { gql } from "@apollo/client";

const VALIDATE_PROMO_CODE = gql`
  mutation ValidatePromoCode($productId: String!, $promoCode: String!) {
    validateCoupon(
      input: { productId: $productId, promotionCode: $promoCode }
    ) {
      coupon {
        id
        valid
        description
        percentOff
        amountOff
        currency
        referralName
        type
      }
    }
  }
`;

export default VALIDATE_PROMO_CODE;
